import {
  ArrowRightOnRectangleIcon,
  BellAlertIcon,
  ChartBarIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  CursorArrowRippleIcon,
  HomeIcon,
  MapIcon,
  PhoneArrowUpRightIcon,
  RectangleStackIcon,
  UserGroupIcon,
  UsersIcon,
  WrenchIcon,
} from '@heroicons/react/24/outline';
import React from 'react';

import { Assets } from '~/assets.g/assets';

const AuditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14.075C14.375 2 14.6583 2.0625 14.925 2.1875C15.1917 2.3125 15.4167 2.49167 15.6 2.725L19.525 7.45C19.675 7.63333 19.7917 7.83333 19.875 8.05C19.9583 8.26667 20 8.49167 20 8.725V17.8C20 18.1333 19.8458 18.3625 19.5375 18.4875C19.2292 18.6125 18.9583 18.5583 18.725 18.325L15.45 15C15.6333 14.7167 15.7708 14.4083 15.8625 14.075C15.9542 13.7417 16 13.3833 16 13C16 11.9 15.6083 10.9583 14.825 10.175C14.0417 9.39167 13.1 9 12 9C10.9 9 9.95833 9.39167 9.175 10.175C8.39167 10.9583 8 11.9 8 13C8 14.1 8.39167 15.0417 9.175 15.825C9.95833 16.6083 10.9 17 12 17C12.3833 17 12.7417 16.9542 13.075 16.8625C13.4083 16.7708 13.7167 16.6333 14 16.45L17.875 20.3C18.1917 20.6167 18.2667 20.9792 18.1 21.3875C17.9333 21.7958 17.625 22 17.175 22H6ZM12 15C11.45 15 10.9792 14.8042 10.5875 14.4125C10.1958 14.0208 10 13.55 10 13C10 12.45 10.1958 11.9792 10.5875 11.5875C10.9792 11.1958 11.45 11 12 11C12.55 11 13.0208 11.1958 13.4125 11.5875C13.8042 11.9792 14 12.45 14 13C14 13.55 13.8042 14.0208 13.4125 14.4125C13.0208 14.8042 12.55 15 12 15Z"
      fill="currentColor"
    />
  </svg>
);
// :point_down: add to icon map
// :point_down: add to icon map
const iconMap: Record<string, React.ComponentType<any>> = {
  HomeIcon,
  RectangleStackIcon,
  CursorArrowRippleIcon,
  UsersIcon,
  WrenchIcon,
  BellAlertIcon,
  PhoneArrowUpRightIcon,
  UserGroupIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  ArrowRightOnRectangleIcon,
  ChartBarIcon,
  MapIcon,
  // custom icons
  AuditIcon,
};
const assetIconMap: Record<string, string> = {
  viewSeason: Assets.images.viewSeason!,
  seasonSettings: Assets.images.seasonSettings!,
  assignment: Assets.images.assignment!,
};
// export function getIconByName(iconName?: string, className = 'h-5 w-5') {
//   const IconComponent = iconName && iconMap[iconName] ? iconMap[iconName] : UserGroupIcon;
//   return <IconComponent className={`${className} fill-current`} />;
// }
export function getIconByName(iconName?: string, className = 'h-6 w-6') {
  // Asset-based (SVGs only)
  if (iconName && assetIconMap[iconName]) {
    const src = assetIconMap[iconName];
    return (
      <img
        // style={{ backgroundColor: 'currentColor' }}
        src={src}
        alt={iconName}
        className={className}
      />
    );
  }
  // React component-based
  const IconComponent = iconName && iconMap[iconName] ? iconMap[iconName] : UserGroupIcon;
  return <IconComponent className={`${className} fill-current`} />;
}
